module.exports = __webpack_public_path__ + "static/media/newshxmt.f8308e44.svg";